"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var content_accessor_1 = require("../content-accessor");

var asset_accessor_1 = require("../asset-accessor");

var graphql_asset_accessor_1 = require("./graphql-asset-accessor");

var graphql_file_accessor_1 = require("./graphql-file-accessor");

var string_1 = require("../../util/string");

var GraphQLContentAccessor =
/** @class */
function () {
  function GraphQLContentAccessor(base) {
    this.base = base;
  }

  GraphQLContentAccessor.prototype.raw = function () {
    return this.base;
  };

  GraphQLContentAccessor.prototype.field = function (name) {
    if (this.base) {
      var value = this.base[name];
      return new GraphQLContentAccessor(value);
    }

    return new content_accessor_1.NullAccessor();
  };

  GraphQLContentAccessor.prototype.array = function (name) {
    if (this.base && this.base[name]) {
      var value = this.base[name];
      return value.map(function (v) {
        return new GraphQLContentAccessor(v);
      });
    }

    return [];
  };

  GraphQLContentAccessor.prototype.object = function (name, defaultValue) {
    if (this.base && this.base[name]) {
      var value = this.base[name];
      return value;
    }

    return defaultValue;
  };

  GraphQLContentAccessor.prototype.text = function (name, defaultValue) {
    if (this.base) {
      var value = this.base[name];
      return value;
    }

    return defaultValue;
  };

  GraphQLContentAccessor.prototype.longText = function (name, defaultValue) {
    if (this.base) {
      var container = this.base[name];
      return container && container[name];
    }

    return defaultValue;
  };

  GraphQLContentAccessor.prototype.richText = function (name, defaultValue) {
    if (this.base) {
      var value = this.base[name];
      if (value && value.json) return value.json;
    }

    return defaultValue;
  };

  GraphQLContentAccessor.prototype.slug = function (name, defaultValue) {
    if (this.base) {
      var value = this.base[name];
      return value && string_1.slugify(value);
    }

    return defaultValue;
  };

  GraphQLContentAccessor.prototype.number = function (name, defaultValue) {
    if (this.base) {
      var value = this.base[name];
      return value;
    }

    return defaultValue;
  };

  GraphQLContentAccessor.prototype["boolean"] = function (name, defaultValue) {
    if (this.base) {
      var value = this.base[name];
      return value;
    }

    return defaultValue;
  };

  GraphQLContentAccessor.prototype.asset = function (name) {
    if (this.base) {
      var value = this.base[name];
      return new graphql_asset_accessor_1.GraphQLAssetAccessor(value);
    }

    return new asset_accessor_1.NullAssetAccessor();
  };

  GraphQLContentAccessor.prototype.type = function () {
    if (this.base) {
      if (this.base['__typename']) {
        return this.base['__typename'];
      }

      console.error("GraphQLContentAccessor: type() requested on a entry without __typename. Make sure you include __typename in your query!");
      return 'unknown';
    }

    return new content_accessor_1.NullAccessor().type();
  };

  GraphQLContentAccessor.prototype.file = function (name) {
    if (this.base) {
      var value = this.base[name];
      return new graphql_file_accessor_1.GraphQLFileAccessor(value);
    }

    return new asset_accessor_1.NullFileAccessor();
  };

  return GraphQLContentAccessor;
}();

exports.GraphQLContentAccessor = GraphQLContentAccessor;